import gql from "graphql-tag";

export const QUERY_HOME_DASHBOARD = gql`
  query HOME_DASHBOARD {
    homeDashboard {
      signedUrl
    }
  }
`;
